const getters = {
  /*
   * 获取二维码ID
   * @param state vuex
   * return QRCodeID {number} 二维码ID
   * */
  getQrcodeId: state =>
    state.QRCodeID > 0 ? state.QRCodeID : window.localStorage.getItem('QRCodeID'),
  /*
   * 获取二维码分类
   * @param state vuex
   * return QRCodeType {string} 二维码分类
   * */
  getQrcodeType: state =>
    state.QRCodeType ? state.QRCodeType : window.localStorage.getItem('QRCodeType'),
}
export default getters
